import { render, staticRenderFns } from "./SwapsInvoices.vue?vue&type=template&id=0c57a7ab"
import script from "./SwapsInvoices.vue?vue&type=script&lang=ts"
export * from "./SwapsInvoices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports